module.exports = __webpack_public_path__ + "static/media/hw_ne_24.ae237ea7.flv";